var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "change-log" },
    [
      _c("div", { staticClass: "page-header" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c(
              "el-button",
              { attrs: { size: "small" }, on: { click: _vm.handleExport } },
              [
                _c("bi-label", {
                  attrs: { zh: "导出", pt: "Exportar", inline: "" },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-card",
        { staticClass: "filter-card", attrs: { shadow: "never" } },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.searchParam,
                "label-position": "top",
                size: "small",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "kw-search" },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c(
                                "el-select",
                                {
                                  model: {
                                    value: _vm.searchParam.params.kwType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.searchParam.params,
                                        "kwType",
                                        $$v
                                      )
                                    },
                                    expression: "searchParam.params.kwType",
                                  },
                                },
                                _vm._l(_vm.kwTypeOptions, function (o) {
                                  return _c("el-option", {
                                    key: o.value,
                                    attrs: {
                                      label:
                                        o.label +
                                        (o.labelPt ? " / " + o.labelPt : ""),
                                      value: o.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: { minRows: 4, maxRows: 4 },
                              placeholder: _vm.$t("GlobalSetObj.pleaseInput"),
                            },
                            model: {
                              value: _vm.searchParam.params.kw,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchParam.params, "kw", $$v)
                              },
                              expression: "searchParam.params.kw",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("bi-label", {
                                attrs: {
                                  zh: "变更时间",
                                  pt: "Data da Alteração",
                                  inline: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "daterange",
                              "value-format": "yyyy-MM-dd",
                              "range-separator": "~",
                              "start-placeholder": "开始日期 / Início",
                              "end-placeholder": "结束日期 / Fim",
                            },
                            model: {
                              value: _vm.searchParam.params.time,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchParam.params, "time", $$v)
                              },
                              expression: "searchParam.params.time",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("bi-label", {
                                attrs: { zh: "UF", inline: "" },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "全部 / Todos",
                                multiple: "",
                                "collapse-tags": "",
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.searchParam.params.uf,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchParam.params, "uf", $$v)
                                },
                                expression: "searchParam.params.uf",
                              },
                            },
                            _vm._l(_vm.ufOptions, function (uf) {
                              return _c("el-option", {
                                key: uf.id,
                                attrs: { label: uf.label, value: uf.label },
                              })
                            }),
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("bi-label", {
                                attrs: {
                                  zh: "触发方式",
                                  pt: "Forma de Gatilho",
                                  inline: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                placeholder: "全部 / Todos",
                              },
                              model: {
                                value: _vm.searchParam.params.triggerType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.searchParam.params,
                                    "triggerType",
                                    $$v
                                  )
                                },
                                expression: "searchParam.params.triggerType",
                              },
                            },
                            _vm._l(_vm.triggerOptions, function (o) {
                              return _c("el-option", {
                                key: o.value,
                                attrs: {
                                  label: o.label + " / " + o.labelPt,
                                  value: o.value,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "filter-btns" },
                        [
                          _c("template", { slot: "label" }, [
                            _c("span", { staticClass: "ph-label" }),
                          ]),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.applyFilter },
                            },
                            [
                              _c("bi-label", {
                                attrs: {
                                  zh: "查询",
                                  pt: "Consultar",
                                  inline: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: { click: _vm.resetFilter },
                            },
                            [
                              _c("bi-label", {
                                attrs: {
                                  zh: "重置",
                                  pt: "Redefinir",
                                  inline: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "table-card", attrs: { shadow: "never" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.pagedRows,
                border: "",
                size: "mini",
                "row-class-name": _vm.rowCls,
              },
            },
            [
              _c(
                "el-table-column",
                {
                  attrs: { "min-width": "170", "class-name": "cell-num" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [_vm._v(_vm._s(_vm.fmtLogTime(row)))]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("bi-label", {
                        attrs: { zh: "变更时间", pt: "Data da Alteração" },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { "min-width": "80" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [_c("strong", [_vm._v(_vm._s(row.uf))])]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [_c("bi-label", { attrs: { zh: "UF" } })],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { "min-width": "170", "class-name": "cell-num" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [_vm._v(_vm._s(_vm.fmtCnpj(row.cnpj)))]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [_c("bi-label", { attrs: { zh: "CNPJ" } })],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { "min-width": "150", "class-name": "cell-num" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [_vm._v(_vm._s(row.ie))]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [_c("bi-label", { attrs: { zh: "IE" } })],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { "min-width": "150", "show-overflow-tooltip": "" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return _vm._l(row.changeFields, function (field) {
                          return _c("div", { key: field }, [
                            _vm._v(" " + _vm._s(field) + " "),
                          ])
                        })
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("bi-label", {
                        attrs: { zh: "变更字段", pt: "Campo Alterado" },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { "min-width": "140", "show-overflow-tooltip": "" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return _vm._l(row.beforeValues, function (before) {
                          return _c("div", { key: before }, [
                            _vm._v(_vm._s(before)),
                          ])
                        })
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("bi-label", {
                        attrs: { zh: "变更前", pt: "Valor Anterior" },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { "min-width": "140", "show-overflow-tooltip": "" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return _vm._l(row.afterValues, function (after) {
                          return _c("div", { key: after }, [
                            _vm._v(_vm._s(after)),
                          ])
                        })
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("bi-label", {
                        attrs: { zh: "变更后", pt: "Novo Valor" },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { "min-width": "180" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "tag",
                              class: _vm.triggerCls(row.triggerType),
                            },
                            [
                              _c("span", { staticClass: "dot" }),
                              _vm._v(
                                _vm._s(_vm.triggerZh(row.triggerType)) + " "
                              ),
                              _c("span", { staticClass: "tag-pt" }, [
                                _vm._v(
                                  "/ " + _vm._s(_vm.triggerPt(row.triggerType))
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("bi-label", {
                        attrs: { zh: "触发方式", pt: "Forma de Gatilho" },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { "min-width": "140" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [_vm._v(_vm._s(_vm.operatorText(row)))]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("bi-label", {
                        attrs: { zh: "操作人", pt: "Operador" },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c(
                "el-pagination",
                {
                  staticClass: "cl-pagination",
                  attrs: {
                    "current-page": _vm.searchParam.pageNumber,
                    "page-size": _vm.searchParam.pageSize,
                    "page-sizes": [10, 20, 50],
                    total: _vm.total,
                    layout: "slot, sizes, prev, pager, next, jumper",
                  },
                  on: {
                    "update:currentPage": function ($event) {
                      return _vm.$set(_vm.searchParam, "pageNumber", $event)
                    },
                    "update:current-page": function ($event) {
                      return _vm.$set(_vm.searchParam, "pageNumber", $event)
                    },
                    "update:pageSize": function ($event) {
                      return _vm.$set(_vm.searchParam, "pageSize", $event)
                    },
                    "update:page-size": function ($event) {
                      return _vm.$set(_vm.searchParam, "pageSize", $event)
                    },
                    "current-change": _vm.handlePageChange,
                    "size-change": _vm.handleSizeChange,
                  },
                },
                [
                  _c("span", { staticClass: "pb-total" }, [
                    _vm._v(" 共 " + _vm._s(_vm.total) + " 条"),
                    _c("span", { staticClass: "pb-pt" }, [
                      _vm._v("/ Total: " + _vm._s(_vm.total) + " registros"),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h2", { staticStyle: { "margin-top": "0" } }, [
        _vm._v(" 状态变更日志 "),
        _c("span", { staticClass: "h2-pt" }, [
          _vm._v("Log de Alterações de Status"),
        ]),
      ]),
      _c("div", { staticClass: "desc" }, [
        _c("span", [
          _vm._v("所有 IE 状态变更的留痕记录，可按时间、UF、触发方式筛选"),
        ]),
        _c("span", { staticClass: "desc-pt" }, [
          _vm._v(
            " Registro de todas as alterações de status de IE; filtre por período, UF e forma de gatilho "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }